import React, { useMemo } from 'react';
import { useRequest } from 'ahooks';
import { Button, Modal, Table, Tag } from '@maxtropy/components';
import { apiV2EnergyConsumptionPlanValveStatusChangeLogPost } from '@maxtropy/device-customer-apis-v2';
import { GasScheduleApiRow, ValveStatus } from '../types';
import { buildValveStatusLogRecords, valveStatusTagColorMap, valveStatusTextMap } from '../utils';

interface ValveStatusChangeLogModalProps {
  open: boolean;
  recordRow?: GasScheduleApiRow;
  onCancel: () => void;
}

const switchRecordColumns = [
  {
    title: '操作时间',
    dataIndex: 'operatedAt',
    width: 180,
  },
  {
    title: '操作类型',
    dataIndex: 'type',
    width: 130,
    render: (value: 'manual' | 'automatic') => (
      <Tag color={value === 'automatic' ? 'success' : 'warning'} border="solid">
        {value === 'automatic' ? '自动' : '手动'}
      </Tag>
    ),
  },
  {
    title: '操作指令',
    dataIndex: 'beforeStatus',
    width: 120,
    render: (value: ValveStatus) => (
      <Tag color={valveStatusTagColorMap[value]} border="solid">
        {valveStatusTextMap[value]}
      </Tag>
    ),
  },
  // {
  //   title: '操作后状态',
  //   dataIndex: 'afterStatus',
  //   width: 120,
  //   render: (value: ValveStatus) => (
  //     <Tag color={valveStatusTagColorMap[value]} border="solid">
  //       {valveStatusTextMap[value]}
  //     </Tag>
  //   ),
  // },
  {
    title: '操作人',
    dataIndex: 'operator',
  },
];

const ValveStatusChangeLogModal: React.FC<ValveStatusChangeLogModalProps> = ({ open, recordRow, onCancel }) => {
  const { data: valveStatusChangeLogResponse, loading } = useRequest(
    () =>
      apiV2EnergyConsumptionPlanValveStatusChangeLogPost({
        areaId: recordRow?.id,
        valveId: recordRow?.deviceId,
      }),
    {
      ready: open && !!recordRow,
      refreshDeps: [open, recordRow?.id, recordRow?.deviceId],
    }
  );

  const valveStatusChangeLogRecords = useMemo(
    () => buildValveStatusLogRecords(valveStatusChangeLogResponse?.list),
    [valveStatusChangeLogResponse?.list]
  );

  return (
    <Modal
      title={`开关记录-${recordRow?.mediumName ?? '--'}-${recordRow?.deviceName ?? '--'}`}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="close" onClick={onCancel}>
          关闭
        </Button>,
      ]}
      size="large"
    >
      <Table
        rowKey="id"
        columns={switchRecordColumns}
        dataSource={valveStatusChangeLogRecords}
        loading={loading}
        pagination={false}
      />
    </Modal>
  );
};

export default ValveStatusChangeLogModal;
